module.exports = __webpack_public_path__ + "img/weixin.97336c40.png";